import React from "react";
import "./style.css";
import { Container, Row, Col } from "react-bootstrap";


export const Impress = () => {
  return (
    <Container className="About-header">
      <Row className="mb-5 mt-3">
        <Col lg="12">
          <h1 className="display-4 mb-4">Impressum</h1>
          <hr className="t_border my-4 ml-0 text-'left'" />
        </Col>
      </Row>
      <Row className="sec_sp">
        <div style={{padding: '0 15px'}} id="cc-m-11807656324" className="j-module n j-text ">

          <p style={{textAlign: 'left', paddingLeft: '120px'}}>
            <span><span style={{fontSize: '14px'}}>Planungsbüro</span> <span style={{fontSize: '14px'}}>Richard</span></span>
          </p>

          <p style={{textAlign: 'left', paddingLeft: '120px'}}>
            <span style={{fontSize: '14px'}}>Inge- Meysel- Str. 31</span>
          </p>

          <p style={{textAlign: 'left', paddingLeft: '120px'}}>
            <span style={{fontSize: '14px'}}>31157&nbsp;Sarstedt</span>
          </p>

          <p style={{textAlign: 'left', paddingLeft: '120px'}}>
            <span style={{fontSize: '14px'}}>FON: 05066 - 92 796 42</span>
          </p>

          <p style={{textAlign: 'left', paddingLeft: '120px'}}>
            <span style={{fontSize: '14px'}}>FAX: 05066 - 92 796 43</span>
          </p>

          <p style={{textAlign: 'left', paddingLeft: '120px'}}>
            <span style={{fontSize: '14px'}}>EMAIL: <span style={{fontSize: '14px'}}>info@pb-richard.de</span></span>
          </p>

          <p style={{textAlign: 'left', paddingLeft: '120px'}}>
            <span style={{fontSize: '14px'}}>WEB: <span style={{fontSize: '14px'}}>www.pb-richard.de</span></span>
          </p>

          <p style={{textAlign: 'left', paddingLeft: '120px'}}>
            <span style={{}}>&nbsp;</span>
          </p>

          <p style={{textAlign: 'left', paddingLeft: '120px'}}>
            <span style={{fontSize: '14px'}}>Geschäftsführer:</span>
          </p>

          <p style={{textAlign: 'left', paddingLeft: '120px'}}>
            <span style={{fontSize: '14px'}}>Dipl- Ing. Architekt</span>
          </p>

          <p style={{textAlign: 'left', paddingLeft: '120px'}}>
            <span style={{fontSize: '14px'}}>Marco Richard</span>
          </p>

          <p style={{textAlign: 'left', paddingLeft: '120px'}}>
            &nbsp;
          </p>

          <p style={{textAlign: 'left', paddingLeft: '120px'}}>
            <span style={{fontSize: '14px'}}>Mitglied der Architektenkammer Niedersachsen</span>
          </p>

          <p style={{textAlign: 'left', paddingLeft: '120px'}}>
            <span style={{fontSize: '14px'}}>EL-NR 17.831</span>
          </p>

          <p style={{textAlign: 'left', paddingLeft: '120px'}}>
            &nbsp;
          </p>

          <p style={{textAlign: 'left', paddingLeft: '120px'}}>
            <span style={{fontSize: '14px'}}>Haftungsausschluss:</span>
          </p>

          <p style={{textAlign: 'left'}}>
            <span style={{}}>&nbsp;</span>
          </p>

          <p style={{textAlign: 'left'}}>
            <span style={{}}><span style={{fontSize: '14px'}}></span><span style={{fontSize: '14px'}}> 1. Die Bilder, Texte und/oder graphischen Gestaltungen auf der Website sind</span>
              <span style={{fontSize: '14px'}}>urheberrechtlich geschützt. Das Copyright für</span> <span style={{fontSize: '14px'}}>veröffentlichte, selbst erstellte Objekte bleibt allein bei</span> <span style={{fontSize: '14px'}}>dem Planungsbüro Richard. Kein Teil des Inhalts dieser Website, das gilt</span> <span style={{fontSize: '14px'}}>insbesondere für Graphiken, Tondokumente, Videosequenzen und
                Texte, darf ohne</span> <span style={{fontSize: '14px'}}>schriftliche Genehmigung von dem Planungsbüro Richard in anderen elektronischen</span> <span style={{fontSize: '14px'}}>oder gedruckten
                  Publikationen vervielfältigt oder verwendet werden.</span></span>
          </p>

          <p style={{textAlign: 'left'}}>
            <span style={{fontSize: '14px'}}>&nbsp;</span>
          </p>

          <p style={{textAlign: 'left'}}>
            <span style={{}}><span style={{fontSize: '14px'}}>2. Gemäß §8 des Teledienstgesetz (TDG) ist das Planungsbüro</span> <span style={{fontSize: '14px'}}>Richard für verlinkte
              rechtswidrige Inhalte nur dann verantwortlich, wenn sie</span> <span style={{fontSize: '14px'}}>von den Inhalten Kenntnis hat. Das Planungsbüro Richard ist ausdrücklich nicht</span> <span style={{fontSize: '14px'}}>verpflichtet, aktiv nach rechtwidrigen Inhalten zu suchen. Sämtliche Links und</span> <span style={{fontSize: '14px'}}>Verweise auf Homepage des Planungsbüros Richard wurden zum
                Zeitpunkt der</span> <span style={{fontSize: '14px'}}>Linksetzung überprüft und keine rechtswidrigen Inhalte gefunden. Sollte das</span> <span style={{fontSize: '14px'}}>Planungsbüro Richard auf
                  rechtswidrige Inhalte der verlinkten Seiten aufmerksam</span> <span style={{fontSize: '14px'}}>gemacht werden, so wird es entsprechende Links unverzüglich von der Seite</span> <span style={{fontSize: '14px'}}>entfernen.</span></span>
          </p></div>
      </Row>
    </Container>
  );
};
